import CityPageTemplate from "../city-template/CityPageTemplate";
import { kansasCityConfig } from "./data";

export default function KansasCityPage() {
  return <CityPageTemplate config={kansasCityConfig} />;
}